/* ================================================== */
/* IOS VH
/* ================================================== */

function iosVh() {

	var windowHeight = $(window).height();

	if (checkIos() === true) {
		$('.type--homepage .header').css('height', windowHeight);
	} else {
		$('.type--homepage .header').removeAttr('style');
	}

}

$(document).ready(iosVh());

$(window).on('resize orientationchange', function() {
	iosVh();
});